export const ACTION_TYPES = {
    UPDATE: "Modifica",
    DELETE: "Elimina",
    VIEW: "Visualizzazione",
    CONFIG: "Configurazione",
    DETAILS: "Dettagli",
    MANAGER: "Gestione"
}
